import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigureServiceNisComponent } from './configure-service-nis.component';
import { CoreModule } from '@dm/core';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [ConfigureServiceNisComponent],
    exports: [ConfigureServiceNisComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
    ],
})
export class ConfigureServiceNisModule { }
